import { IStore, IAccType , ITax, IApiResponse, INameExist} from 'src/app/Shared/interface';
import { IFacilityInfo, IAccountHead } from 'src/app/Shared/interface';
import { ITaxDetails, ITaxOptions, IAppliedFor, IAllowanceAccount, IUncollectedAccount } from './../Shared/interface';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import {AppService} from './app.service';



@Injectable({
    providedIn: 'root',
})

export class TaxService {
    private baseURL = this.appService.config.apiBaseUrl;


     private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }

    public getTaxListBind:() => void;

    getTaxLists(): Observable<ITax[]> {
        return this.http.get<ITax[]>(
            `${this.baseURL}/Tax/GetTaxes`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const TaxList = res.body as ITax[];
                    return TaxList;
                }),
                catchError(this.handleError)
            );
    }

    getTaxOptions(): Observable<ITaxOptions[]> {
        return this.http.get<ITaxOptions[]>(
            `${this.baseURL}/Tax/GetTaxOptions`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const TaxOptions = res.body as ITaxOptions[];
                    return TaxOptions;
                }),
                catchError(this.handleError)
            );
    }

    getTaxDetail(Id: number): Observable<ITaxDetails> {
        return this.http.get<ITaxDetails>(
            `${this.baseURL}/Tax/GetTax?Id=${Id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const taxDetails = res.body as ITaxDetails;
                    return taxDetails;
                }),
                catchError(this.handleError)
            );
    }
    getAccType(Id: number): Observable<IAccType[]> {
        return this.http.get<IAccType[]>(
            `${this.baseURL}/General/GetAcctype?Id=${Id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const Acctype = res.body as IAccType[];
                    return Acctype;
                }),
                catchError(this.handleError)
            );
    }

    // getStores(): Observable<IStore[]> {
    //     return this.http.get<IStore[]>(
    //         `${this.baseURL}/holiday/GetStores`,
    //         { observe: 'response' })
    //         .pipe(
    //             map(res => {
    //                 const Stores = res.body as IStore[];
    //                 return Stores;
    //             }),
    //             catchError(this.handleError)
    //         );
    // }

        updateTaxDetails(TaxDetails): Observable<IApiResponse> {

        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if(TaxDetails.Id === 0) {
            url = `${this.baseURL}/Tax/CreateTax`;
        } else {
            url = `${this.baseURL}/Tax/UpdateTaxDetails`;
        }

        return this.http.post<IApiResponse>(url, TaxDetails, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }


    getTaxNameExist(Name: string): Observable<INameExist> {
        return this.http.get<INameExist>(
            `${this.baseURL}/Tax/GetTaxExist?taxName=${Name}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const taxExists = res.body as INameExist;
                    return taxExists;
                }),
                catchError(this.handleError)
            );
    }

    // getIsGrpNameExist(Name: string): Observable<boolean> {
    //     return this.http.get<boolean>(
    //         `${this.baseURL}/UserGroups/GetIsGroupNameExist?grpName=${Name}`,
    //         { observe: 'response' })
    //         .pipe(
    //             map(result => {
    //                 const isExist = result.body as boolean;
    //                 return isExist;
    //             }
    //             ),
    //             catchError(this.handleError)
    //         );
    // }




    deleteTax(taxId: number,connectionId: string) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.post<boolean>(`${this.baseURL}/Tax/DeleteTax?taxId=${taxId}&connectionId=${connectionId}`, options);
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}

